import Members from "./pages/Members";

export default function App() {
  return (
    <div className="App">
      <Members />
    </div>
  );
}
